import { SubmitOfferFormData } from 'src/components/offer/SectionOffer';
import { Address, BasicAddress } from 'src/entities/basic-types/Address';
import { Offer, OfferState } from 'src/entities/offer/Offer';
import OrderProduct from '../response/OrderProduct';
import ShoppingCart from '../response/ShoppingCart';
import SelectedProduct from './SelectedProduct';

export class CartOfferRequestDTO {
    public readonly state: OfferState;
    public readonly orderProductList: SelectedProduct[];

    public readonly customerId?: number;
    public readonly publicId?: string;
    public readonly billingAddress?: Address | BasicAddress;
    public readonly deliveryAddress?: Address | BasicAddress;

    public readonly additionalProperties?: Record<string, any>;
    public readonly extra?: Record<string, string>;
    public readonly selectedSourceDepot?: string;

    constructor(
        orderProductList: SelectedProduct[],
        customerId?: number,
        publicId?: string,
        billingAddress?: Address | BasicAddress,
        deliveryAddress?: Address | BasicAddress,
        extra?: Record<string, string>,
        additionalProperties?: Record<string, any>,
        selectedSourceDepot?: string
    ) {
        this.state = 'new';
        this.orderProductList = orderProductList;

        this.customerId = customerId;
        this.publicId = publicId;
        this.billingAddress = billingAddress;
        this.deliveryAddress = deliveryAddress;

        this.additionalProperties = additionalProperties;
        this.extra = extra;
        this.selectedSourceDepot = selectedSourceDepot;
    }

    static fromShoppingCart(shoppingCart: ShoppingCart, data?: SubmitOfferFormData): CartOfferRequestDTO {
        const shoppingCartProducts = shoppingCart
            .getFlatProductList()
            .map((product: OrderProduct) => SelectedProduct.fromOrderProduct(product));

        // create new CartRequestDTO and filter out products with zero quantity
        return new CartOfferRequestDTO(
            shoppingCartProducts.filter(product => product.quantity > 0),
            data?.customerId,
            data?.publicId,
            data?.billingAddress,
            data?.deliveryAddress,
            data?.extra,
            data?.additionalProperties,
            data?.selectedSourceDepot
        );
    }

    static fromOffer(offer: Offer): CartOfferRequestDTO {
        return new CartOfferRequestDTO(
            offer.orderProductList,
            offer.customerId,
            offer.publicId,
            offer.billingAddress,
            offer.deliveryAddress
        );
    }
}
